module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/copy-92c2cdc27cc0e5217b545db7670bc360.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/copy.svg
// module id = pVIF
// module chunks = 24